import { render, staticRenderFns } from "./StockTab.vue?vue&type=template&id=1be6f34f&scoped=true"
import script from "./StockTab.vue?vue&type=script&lang=js"
export * from "./StockTab.vue?vue&type=script&lang=js"
import style0 from "./StockTab.vue?vue&type=style&index=0&id=1be6f34f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be6f34f",
  null
  
)

export default component.exports